import { fetchWrapper as fetch } from "helpers/fetch";

const processResponse = json => {
  if (json.error || json.status === 'error') {
    let reason = json.additional_info && json.additional_info.reason;
    if (reason === 'insufficient_permissions' && !json.additional_info.role) reason = 'excluded_from_clan';
    return Promise.reject(reason);
  }
  return json.building;
};

export const activateBonus = (url, clanId, modifierId, buildingId) => {
  return fetch(url.replace('{clan_id}', clanId), {
    method: 'POST',
    body: {
      modifier_type_id: modifierId,
      building_id: buildingId
    }
  }).then(processResponse);
};